function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23249"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20092",
    style: {
      fill: "transparent"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17779",
    d: "M9 6.333V9l2 2m4-2a6 6 0 1 1-6-6 6 6 0 0 1 6 6z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};

export default SvgClock;